// extracted by mini-css-extract-plugin
export var fadeInDown = "styles-module--fadeInDown--37e47";
export var firstGlow = "styles-module--first-glow--aa4e8";
export var showMoreIcon = "styles-module--showMore-icon--7d89c";
export var showMoreText = "styles-module--showMore-text--0f685";
export var showMoreWrapper = "styles-module--showMore-wrapper--fce4c";
export var suptitle = "styles-module--suptitle--e31de";